import React from "react";
import {MonthlyRevenueReportsListAdmin} from "../reportsView";

const MonthlyRevenueReportsAdmin = () => {
  return (
    <div className="">
      <main className="content">
        <div className="container-fluid p-0">
          <h1>Monthly Revenue Reports</h1>
          <p style={{color: 'red'}}>Report for prior month gets finalized by the 15th of every consecutive month.</p>
          <hr />
          <MonthlyRevenueReportsListAdmin />
        </div>
      </main>
    </div>
  );
};

export default MonthlyRevenueReportsAdmin;